<div style="background-color: #F5F7F8; height: 100vh; overflow-y: scroll; padding: 10px;">
    <img style="width: 22px; height: 22px; position: absolute; top: 35px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
    <h1 style="font-weight: bold; text-align: center; font-size: 16px;">Правни документи</h1>

    <div style="margin-bottom: 10px; background-color: white; padding: 10px; border-radius: 10px;" >
        <div (click)="this.openDocument(files.GTC)" style="margin-top: 7px;">
            <div style="margin-top: 7px;">
                <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px;" src="/assets/images/documents/icon-terms.svg" alt="">
                <p style="display: inline-block; font-weight:500;">{{ this.pageDetails().GTC }}</p>
            </div>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <div (click)="this.openDocument(files.PPC)" style="margin-top: 7px;">
            <div style="margin-top: 7px;">
                <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px;" src="/assets/images/documents/icon-legal.svg" alt="">
                <p style="display: inline-block; font-weight:500;">{{ this.pageDetails().DPP }}</p>
            </div>
        </div>
    </div>
</div>